/**
 * PIMS integration requests from the Integrations settings page. A request is stored (one per
 * account and PIMS, keeping the first date) so the card can say "Requested" across reloads.
 *
 * Reads go straight to Supabase (RLS: the account's own users). The write goes through API-Server,
 * which resolves the clinic from the session (`apiFetch` supplies `X-HappyDoc-Account-Id`), stores
 * the row and posts to Slack.
 */

import { apiFetch } from "@common/lib/api";
import { supabase } from "@common/lib/supabaseClient";

export const integrationRequestsQueryKey = (accountId?: string) => ["integration-requests", accountId] as const;

/** PIMS name -> ISO date it was first requested. Throws on a failed read. */
export async function fetchIntegrationRequests(accountId: string): Promise<Record<string, string>> {
    const { data, error } = await supabase
        .from("integration_requests")
        .select("pims, requested_at")
        .eq("account_id", accountId);
    if (error) throw error;
    return Object.fromEntries((data ?? []).map((row) => [row.pims, row.requested_at]));
}

/** Throws on failure, so the caller can tell the clinic the request did not go through. */
export async function requestIntegration(pims: string, email?: string): Promise<void> {
    await apiFetch("slack/integration-request", { method: "POST", json: { pims, email } });
}
